module.exports = __webpack_public_path__ + "img/mainLogo.a21b0bc9.svg";